import styles from './Tour.module.css';
import ProgressDots from '../ProgressDots/ProgressDots';

const getAnswerIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#aaa">
            <path d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h357l-80 80H200v560h560v-278l80-80v358q0 33-23.5 56.5T760-120H200Zm280-360ZM360-360v-170l367-367q12-12 27-18t30-6q16 0 30.5 6t26.5 18l56 57q11 12 17 26.5t6 29.5q0 15-5.5 29.5T897-728L530-360H360Zm481-424-56-56 56 56ZM440-440h56l232-232-28-28-29-28-231 231v57Zm260-260-29-28 29 28 28 28-28-28Z" />
        </svg>
    )
}
const getPeerIcon = () => {
    return (
        <svg width='40' height='20' xmlns='http://www.w3.org/2000/svg'>
            <path d='M0 21v-2.756c0-1.254.642-2.275 1.925-3.063C3.208 14.394 4.9 14 7 14c.38 0 .744.007 1.094.022.35.014.685.05 1.006.11a7.281 7.281 0 0 0-.919 1.924 7.172 7.172 0 0 0-.306 2.1V21H0Zm10.5 0v-2.844c0-.933.255-1.786.766-2.56.51-.772 1.232-1.45 2.165-2.034.934-.583 2.05-1.02 3.347-1.312 1.298-.292 2.705-.438 4.222-.438 1.546 0 2.968.146 4.266.438 1.298.292 2.413.73 3.347 1.313.933.583 1.647 1.261 2.143 2.034.496.773.744 1.626.744 2.56V21h-21Zm23.625 0v-2.844a7.85 7.85 0 0 0-.284-2.143 6.851 6.851 0 0 0-.854-1.882 7.26 7.26 0 0 1 .985-.11C34.307 14.008 34.65 14 35 14c2.1 0 3.792.386 5.075 1.16 1.283.772 1.925 1.8 1.925 3.084V21h-7.875ZM7 12.25c-.963 0-1.786-.343-2.472-1.028C3.843 10.536 3.5 9.712 3.5 8.75c0-.992.343-1.823 1.028-2.494A3.407 3.407 0 0 1 7 5.25c.992 0 1.823.335 2.494 1.006.67.671 1.006 1.502 1.006 2.494 0 .963-.335 1.786-1.006 2.472-.671.685-1.502 1.028-2.494 1.028Zm28 0c-.962 0-1.786-.343-2.472-1.028-.685-.686-1.028-1.51-1.028-2.472 0-.992.343-1.823 1.028-2.494A3.407 3.407 0 0 1 35 5.25c.992 0 1.823.335 2.494 1.006.67.671 1.006 1.502 1.006 2.494 0 .963-.335 1.786-1.006 2.472-.671.685-1.502 1.028-2.494 1.028ZM21 10.5c-1.458 0-2.698-.51-3.719-1.531-1.02-1.021-1.531-2.26-1.531-3.719 0-1.487.51-2.734 1.531-3.74C18.302.502 19.541 0 21 0c1.488 0 2.734.503 3.74 1.51 1.007 1.006 1.51 2.253 1.51 3.74 0 1.458-.503 2.698-1.51 3.719C23.735 9.989 22.489 10.5 21 10.5Z' fill='#bbb' />
        </svg>
    )
}
const getTakeSurveyIcon = () => {
    return (
        <svg xmlns='http://www.w3.org/2000/svg' height='28' viewBox='0 -960 960 960' width='28'><path fill='#bbb' d='M180-12q-24 0-42-18t-18-42v-600q0-24 18-42t42-18h405l-60 60H180v600h600v-348l60-60v408q0 24-18 42t-42 18H180Zm300-360Zm182-352 43 42-285 284v86h85l286-286 42 42-303 304H360v-170l302-302Zm171 168L662-724l100-100q17-17 42.311-17T847-823l84 85q17 18 17 42.472T930-654l-97 98Z' /></svg>
    )
}
const getResultsIcon = () => {
    return (
        <svg xmlns='http://www.w3.org/2000/svg' height='28' viewBox='0 -960 960 960' width='28'><path fill='#bbb' d='M280-280h80v-280h-80v280Zm160 0h80v-400h-80v400Zm160 0h80v-160h-80v160ZM200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm0-80h560v-560H200v560Zm0-560v560-560Z' /></svg>
    )
}

const getContent = (section, step) => {
    if (section === "Benchmarking") {
        switch (step) {
            case 1:
                return (
                    <div className={styles.tourStep}>
                        <h2>Welcome to Advisor Insight!</h2>
                        <p>Our goal is to provide you with insights that help you improve your advisory practice. We do this by asking you questions and comparing your answers to those of industry peers, while maintaining your confidentiality.</p>
                    </div>
                );
            case 2:
                return (
                    <div className={styles.tourStep}>
                        <h2>Toggle between Benchmarking and Insights</h2>
                        <p><strong>Benchmarking:</strong> A more quantitative set of metrics around advisor practices</p>
                        <p><strong>Insights:</strong> Timely perspectives on trends affecting advisors</p>
                    </div>
                );
            case 3:
                return (
                    <div className={styles.tourStep}>
                        <h2>Filter benchmarking charts by various practice areas</h2>
                        <p>Drill into the most important metrics influencing your practice's success</p>
                        <p>Gain a deeper understanding of how other advisors are positioned</p>
                        <p>Compare your situation to a select group of peer advisors</p>
                    </div>
                );
            case 4:
                return (
                    <div className={styles.tourStep}>
                        <p>Click <strong>Begin survey</strong> to take a short survey&hellip;</p>
                    </div>
                );
            case 5:
                return (
                    <div className={styles.tourStep}>
                        <p>&hellip;or click the {getAnswerIcon()} icon to submit your response to a specific topic.</p>
                    </div>
                );
            case 6:
                return (
                    <div className={styles.tourStep}>
                        <h2>Choose your benchmark</h2>
                        <p>Use the {getPeerIcon()} icon to instantly toggle between <strong>all</strong> advisors or a select <strong>peer group</strong>.</p>
                    </div>
                );
            default:
                return null;
        }
    } else if (section === "Insights") {
        switch (step) {
            case 1:
                return (
                    <div className={styles.tourStep}>
                        <p><strong>Insights</strong> houses surveys focused those trends impacting advisors today and provides immediate feedback on what other advisors are thinking.</p>
                    </div>
                );
            case 2:
                return (
                    <div className={styles.tourStep}>
                        <p>Quickly filter surveys to find those most recently added, those seen as advisor favorites, or even those eligible for rewards.</p>
                    </div>
                );
            case 3:
                return (
                    <div className={styles.tourStep}>
                        <p>Roll over a survey card to get a full description of the survey and how it relates to your practice.</p>
                    </div>
                );
            case 4:
                return (
                    <div className={styles.tourStep}>
                        <p>Click the {getTakeSurveyIcon()} icon to participate in the survey.</p>
                    </div>
                );
            case 5:
                return (
                    <div className={styles.tourStep}>
                        <p>For any completed the survey, click the {getResultsIcon()} icon to view the aggregate responses.</p>
                    </div>
                );
            case 6:
                return (
                    <div className={styles.tourStep}>
                        <p>Hide completed surveys using the toggle button to identify which surveys you haven’t yet taken.</p>
                    </div>
                );
            default:
                return null;
        }
    }
}

const Tour = ({ section, step, steps, onPrev, onNext, onClose, top, left, right, position, showSpotlight, spotlightDimensions, showCallout = true }) => {

    let
        style;

    if (position === "absolute") {
        style = {
            top: `${top}px`
        };
        if (left) {
            style.left = `${left}px`;
            style.transform = "translateX(0)";
        } else if (right) {
            style.left = `${right}px`;
            style.transform = "translateX(-100%)";
        }
    }

    return (
        <>
            {
                showSpotlight
                    ?
                    <div className={styles.spotlightContainer}>
                        <div className={styles.spotlight} style={{
                            left: `${spotlightDimensions.left}px`,
                            top: `${spotlightDimensions.top}px`,
                            width: `${spotlightDimensions.width}px`,
                            height: `${spotlightDimensions.height}px`,
                        }}></div>
                    </div>
                    :
                    <div className={styles.modal}></div>
            }
            {
                showCallout &&
                <div className={`${styles.container} ${(position === "absolute") ? styles.absolute : styles.fixed}`} style={style}>
                    {getContent(section, step)}
                    <div className={styles.buttonContainer}>
                        <button className={styles.prevButton} onClick={onPrev} disabled={step === 1}>Back</button>
                        <ProgressDots totalSteps={steps} currentStep={step} />
                        <button className={styles.nextButton} onClick={onNext} disabled={step === steps}>Next</button>
                    </div>
                    <button className="close" onClick={onClose}></button>
                </div>
            }
        </>
    );
};

export default Tour;
